module.exports = "<section class=\"nn-live-event container--large\"><div class=container><nn-base-module-header title=::translations.liveEvent></nn-base-module-header><div class=nn-live-event__iframe-wrapper><div><iframe ng-src=\"{{ ::module.iframeUrl }}\" width=100% height=100% frameborder=0 webkitallowfullscreen mozallowfullscreen allowfullscreen scrolling=no id=event-iframe></iframe></div></div><h2 class=nn-live-event__title ng-bind-html=::module.eventTitle></h2><p class=nn-live-event__subtitle ng-bind-html=::module.eventSubtitle></p></div></section>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-modules/nn-live-event/nn-live-event.directive.html
// module id = 1001
// module chunks = 0